import React, { FC } from 'react';
import { navigationRef, Popup } from '@helpers';
import ActionMenu from '@components/common/actionMenu';
import { ColorFunction } from '@styles/colors/types';
import ClampingToolDetails from '@components/clampingTool/components/clampingToolDetails';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';

interface ToolModalProps {
  C: ColorFunction;
  setActionsModalOpen: (state: boolean) => void;
  minWidth?: number;
}

const ToolModal: FC<ToolModalProps> = (props) => {
  const { setActionsModalOpen, C, minWidth } = props;

  const route = navigationRef.current?.getCurrentRoute();
  const params = route?.params;

  const items = [
    {
      testID: TEST_IDS.detailsModal.tools.add,
      lable: {
        color: 'Label/Light/Primary',
        name: 'Add',
      },
      icon: {
        name: 'plus',
        width: 18,
        height: 18,
        color: 'Label/Light/Primary',
      },
      onPress: () => {
        setActionsModalOpen(false);
        Popup({
          Component: (p) => <ClampingToolDetails {...{ ...p, params, newTool: true }} />,
        });
      },
    },
  ];

  return <ActionMenu {...{ C, items, ...(minWidth ? { minWidth } : {}) }} />;
};

export default ToolModal;
